const invertedMessages = {
  'Access Restricted': 'certs.access.restricted',
  'The user does not have sufficient privileges to access certification.':
    'certs.access.restricted.subtitle',
  'Back To Home Page': 'certs.backto.homepage',
  'End of results': 'certs.all.records.fetched',
  'Scroll to top': 'certs.scroll.to.top',
  'Bulk Operation is in Progress': 'certs.bulk.operation.in.progress',
};

export default invertedMessages;
